export const blockIconsCommonactionsErrorNew = (
	<span className='material-symbols-outlined'>error</span>
);
